export interface CatalogParams {
  search?: string;
  type?: string;
  coverage?: string;
  page?: number;
  size?: number;
}

export interface HoldingsParams {
  search?: string;
  type?: string;
  status?: string;
  coverage?: string;
  page?: number;
  size?: number;
}

export interface ActivityParams {
  module?: string;
  status?: string;
  search?: string;
  correlationId?: string;
  operationId?: string;
  from?: string;
  to?: string;
  page?: number;
  size?: number;
}

/**
 * Centralized query key factory for React Query.
 * Ensures consistent cache key structure across all API queries.
 */
export const queryKeys = {
  health: ['health'] as const,

  routes: {
    all: ['routes'] as const,
    detail: (id: string) => ['routes', id] as const,
    products: (id: string) => ['routes', id, 'products'] as const,
    current: ['routes', 'current'] as const,
  },

  holdings: (params?: HoldingsParams) => ['holdings', params] as const,
  holdingsCells: (page?: number, size?: number) => ['holdings', 'cells', { page, size }] as const,

  vesselMapState: ['vessels', 'map-state'] as const,

  ports: (search: string) => ['ports', search] as const,
  allPorts: ['ports', 'all'] as const,

  catalog: (params: CatalogParams) => ['catalog', params] as const,

  orders: {
    all: ['orders'] as const,
    detail: (id: string) => ['orders', id] as const,
  },

  updates: {
    operations: ['updates', 'operations'] as const,
    operation: (id: string) => ['updates', 'operations', id] as const,
    licenses: ['updates', 'licenses'] as const,
  },

  transfers: {
    ecdisTargets: ['transfers', 'ecdisTargets'] as const,
    detail: (id: string) => ['transfers', id] as const,
    history: ['transfers', 'history'] as const,
  },

  activity: (params: ActivityParams) => ['activity', params] as const,

  notifications: ['notifications'] as const,

  branding: ['branding'] as const,
};
